import React from 'react';

import BackgroundImage from '../../media/images/LoginBackground.jpg';

import Header from '../Header';

import { useTranslation, withTranslation } from 'react-i18next';

import './ExpiredListMessage.css';
import {Link, useLocation} from "react-router-dom";
import jwt from "jwt-decode";
import {isJwtExpired} from "../../global";

function useIsGifteeViewer(): boolean {
    const {pathname} = useLocation();
    if (pathname.startsWith('/giftee')) {
        return true;
    }
    const token = localStorage.getItem('token') ?? sessionStorage.getItem('token');
    if (!token || isJwtExpired(token)) {
        return false;
    }
    try {
        const user: { role?: unknown } = jwt(token);
        return Number(user.role) === 1;
    } catch {
        return false;
    }
}

function ListUnavailableMessage() {
    const {t} = useTranslation();
    const isGiftee = useIsGifteeViewer();

    return (
        <div className="ExpiredListMessageContainer">
            <Header hideLogout={true} showWishlistLink={false} showCart={false}/>
            <div>
                <div className={'container-images-and-text'}>
                    <div style={{backgroundImage: `url(${BackgroundImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} className="ExpiredListImageContainer">
                    </div>
                    <div className={'ExpiredListInfosContainer'}>
                        <h1>{t('listUnavailableMessageTitle')}</h1>
                        <h3>{t('listUnavailableMessageSubtitle')}</h3>
                        {isGiftee ? (
                            <div
                                className="ButtonContainer"
                                style={{
                                    maxWidth: '320px',
                                    width: '100%',
                                    marginTop: '24px',
                                    alignSelf: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                <Link
                                    className="Fgift-button"
                                    style={{ width: '100%', height: '50px!important', display: 'inline-block' }}
                                    to="/login"
                                >
                                    {t('loginSignupPage.signup')}
                                </Link>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(ListUnavailableMessage);
